import { useEffect, useState, useRef, useMemo } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { http } from "../auth";
import { Row, Col, Form, Button, Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import { telefonos, documento } from "../utils/bancos";
import { FiCheck } from "react-icons/fi";
import { RxCross1, RxCross2 } from "react-icons/rx";
import { useThemeManager } from "../Hooks/ThemeManager";

const PagoC2P = ({ id_doc, id_servicio, factura, onBankChange, loadResume }) => {
  const token = localStorage.getItem("token");
  const [plaza, setPlaza] = useState([]);
  const [tesoro, setTesoro] = useState([]);
  const [c2pTesoro, setC2pTesoro] = useState(true);
  const [c2pPlaza, setC2pPlaza] = useState(false);
  const [loading, setLoading] = useState(false);
  const [bank, setBank] = useState("");
  const [nacionalidad, setNacionalidad] = useState("V");
  const [ci, setCi] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState(false);
  const [step2, setStep2] = useState(false);
  const [status, setstatus] = useState(false);
  const [activate, setActivate] = useState([]);
  const [telefono, setTelefono] = useState([]);
  const [changeForm, setChangeForm] = useState(false);
  const [msg, setMsg] = useState("");
  const [step, setStep] = useState(false);
  const [ref, setRef] = useState("");
  const { themeColors } = useThemeManager();
  const [selectedC2P, setSelectedC2P] = useState(null);
  const c2p = true;
  const customId = "custom-id-yes";

  const {
    register,
    handleSubmit,
    setValue,
    control,
    reset,
    watch,
    formState: { errors },
  } = useForm();

  const fetchBankData = async (bankType) => {
    try {
      const endpoint = bankType === "tesoro" ? "/tes/c2p/bancos" : "/bp/c2p/bancos";

      const response = await http.get(endpoint, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (bankType === "tesoro") {
        setTesoro(response.data);
      } else {
        setPlaza(response.data);
      }
    } catch (error) {
      setStep2(true);

      if (bankType === "plaza") {
        setError(true);
      }

      if (error.response && [400, 404, 409, 422, 500, 503].includes(error.response.status)) {
        toast.error(error.response.data.detail || "Error en la solicitud", {
          toastId: customId,
          position: "top-center",
        });
      }
    }
  };

  useEffect(() => {
    if (selectedC2P === "Banco del Tesoro") {
      fetchBankData("tesoro");
    } else if (selectedC2P === "Banco Plaza") {
      fetchBankData("plaza");
    }
  }, [selectedC2P]);

  const mediosOnline = async () => {
    setLoading(true);
    try {
      let response = await http.get(`/config/estado_medios_online`);
      setActivate(response.data);
    } catch (error) {
      if (![200, 401].includes(error?.response?.status)) {
        toast.error("Ocurrio un error al cargar los medios online");
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    mediosOnline();
  }, []);

  const C2P = useMemo(() => {
    const result = [];
    activate.forEach((bank) => {
      if (bank.c2p && bank.c2p.enabled_j) {
        result.push({
          banco: bank.banco,
          logo_url: bank?.c2p?.logo_url,
          id: bank.id || bank.banco,
        });
      }
    });
    return result;
  }, [activate]);

  // Efecto para enviar el banco seleccionado al padre
  useEffect(() => {
    if (selectedC2P) {
      const bancoActual = C2P.find((b) => b.id === selectedC2P);
      if (bancoActual && onBankChange) {
        onBankChange(bancoActual.banco);
      }
    }
  }, [selectedC2P, C2P, onBankChange]);

  // Efecto para seleccionar el primer banco por defecto
  useEffect(() => {
    if (C2P.length > 0 && !selectedC2P) {
      const primerBanco = C2P[0];
      setSelectedC2P(primerBanco.id);
    }
  }, [C2P.length]);

  const handleC2PSelection = (bankId) => {
    setSelectedC2P(bankId);
  };

  console.log("selectedC2p", selectedC2P);

  const cedula = (event) => {
    const inputValue3 = event.target.value;
    const numericValue3 = inputValue3.replace(/[^0-9]/g, "");
    setCi(numericValue3.toString());
  };

  const numero = (event) => {
    const inputValue2 = String(event.target.value);
    const numericValue2 = inputValue2.replace(/\D/g, "");
    const limitedValue = numericValue2.slice(0, 7);
    setTelefono(limitedValue);
  };

  const tokenc2p = (e) => {
    const input = e.target;
    let value = input.value;

    value = value.replace(/\D/g, "");
    if (value.length > 8) {
      value = value.slice(0, 8);
    }

    input.value = value;
  };

  const banco = () => {
    setC2pTesoro(!c2pTesoro);
    setC2pPlaza(!c2pPlaza);
  };

  const onSubmit = async (data) => {
    setChangeForm(true);

    const showWarning = (message) => {
      toast.warning(message, {
        toastId: customId,
        position: "top-center",
      });
      setChangeForm(false);
    };

    if (!ci || ci.length < 6) {
      showWarning("Debe ingresar un número de documento válido");
      return;
    }

    if (!telefono || telefono.length < 7) {
      showWarning("Debe ingresar un número telefónico válido");
      return;
    }

    if (!data.banco || data.banco === "0") {
      showWarning("Debe seleccionar el banco origen");
      return;
    }

    if (!data.token || data.token.length < 8) {
      showWarning("Debe ingresar el token de 8 dígitos");
      return;
    }

    if (factura) {
      data.id_docs = id_doc;
      delete data.id_servicio;
    } else if (!factura) {
      data.id_servicio = Array.isArray(id_servicio) ? id_servicio : [id_servicio];
      delete data.id_docs;
    }

    data.telefono = data.pre + telefono;
    data.id = nacionalidad + ci;

    try {
      const response = await http.post(`${c2pTesoro ? "/tes/c2p-j" : "/bp/c2p-j"}`, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setStep(true);
      setstatus(true);
      setMessage("Su pago ha sido procesado de forma exitosa.");
      setMsg(response.data.message);
      reset();
    } catch (error) {
      setstatus(false);
      if ([400, 404, 409, 422, 500, 503].includes(error?.response?.status)) {
        setStep(true);
        setMessage(error?.response?.data?.detail);
      }
    } finally {
      setChangeForm(false);
    }
  };

  const RespondC2P = () => {
    return (
      <>
        <Modal
          size="md"
          show={step}
          centered
          className="my-modal no-border"
          onHide={() => {}}
          backdrop="static"
          keyboard={false}
        >
          <div className="d-flex justify-content-end">
            <button onClick={() => setStep(false)} className="eliminarBG me-4 mt-2">
              <RxCross2 className="color-primary" style={{ fontSize: 35 }} />
            </button>
          </div>
          <Modal.Body className="text-center p-4">
            <div
              className="center-all"
              style={{
                fontSize: "120px",
              }}
            >
              {status ? (
                <FiCheck
                  className="success-icon"
                />
              ) : (
                <RxCross1 className="error-icon"
                />
              )}
            </div>
            <div className="color-secondary">
              <h2 className="font-styles mb-5">{message}</h2>
              {status && <h3 className="font-styles ">{msg}</h3>}
            </div>
          </Modal.Body>
        </Modal>
      </>
    );
  };

  return (
    <div>
      <RespondC2P />
      <div className="mt-5 color-secondary">
        <span className="center-all header-bill mt-5">Plataforma bancaria</span>
      </div>
      {loading ? (
        <div className="placeholder-glow">
          {[1, 2].map((i) => (
            <div key={i} className="formasBorder border-card mt-2 d-flex align-items-center p-3" style={{ gap: 12 }}>
              <div className="placeholder rounded-circle flex-shrink-0" style={{ width: 20, height: 20 }}></div>
              <div className="flex-grow-1">
                <div className="placeholder col-4 mb-1" style={{ height: 14 }}></div>
              </div>
              <div className="placeholder flex-shrink-0" style={{ width: 50, height: 50, borderRadius: 8 }}></div>
            </div>
          ))}
        </div>
      ) : (
      <div className="formasBorder border-card mt-2" onClick={banco}>
        {C2P.map((bank, index) => (
          <Row className="p-2" key={index} onClick={() => handleC2PSelection(bank.id)}>
            <Col xs={8} sm={9} className="col-metodo-2 font-bills-details">
              <div className="col-metodo-2 me-4">
                <Form.Check
                  className="check-custom"
                  type="radio"
                  aria-label={bank.banco}
                  name={bank.banco}
                  checked={selectedC2P === bank.id}
                  onChange={() => handleC2PSelection(bank.id)}
                  id={`c2p-${bank.id}`}
                />
              </div>
              <div className="col-metodo">
                {bank.banco === "Banco del Tesoro" && <span className="title-bank">BT Pagos</span>}
                <span className="title-bank">{bank.banco}</span>
              </div>
            </Col>
            <Col xs={4} sm={3} className="col-view">
              <img className="bank-logo" src={bank.logo_url} alt={`${bank.banco} logo`} />
            </Col>
          </Row>
        ))}
      </div>
      )}
      <span className="center-all header-bill mt-4 color-secondary">
        Datos asociados a su pago
      </span>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="form-pago border-card mt-2">
          <div className="padding-form">
            <>
              <Row className="g-3">
                <Col xs={4} sm={3} xxl={3}>
                  <Form.Group className="mb-2">
                    <Form.Label>Tipo doc.</Form.Label>
                    <Form.Select
                      onChange={(e) => setNacionalidad(e.target.value)}
                      className="custom-select-no-arrow align-selector"
                    >
                      {documento.map((banco) => (
                        <option key={banco.value} value={banco.value}>
                          {banco.label}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col xs={8} sm={9} xxl={9}>
                  <Form.Group className="mb-2">
                    <Form.Label>Doc. del pagador</Form.Label>
                    <Form.Control onChange={cedula} type="number" />
                  </Form.Group>
                </Col>
              </Row>
              <Row className="g-3">
                <Col xs={12}>
                  <Form.Group className="mb-2">
                    <Form.Label>Banco de origen</Form.Label>
                    <Form.Select className="custom-select-no-arrow" {...register("banco")}>
                      <>
                        <option value="" disabled selected>
                          Seleccione el banco origen...
                        </option>
                        {c2pTesoro &&
                          tesoro?.map((bank) => (
                            <option key={bank?.codigo} value={bank?.codigo}>
                              {bank?.nombre}
                            </option>
                          ))}
                        {c2pPlaza &&
                          plaza?.bancos?.map((bank) => (
                            <option key={bank?.codigo} value={bank?.codigo}>
                              {bank?.nombre}
                            </option>
                          ))}
                      </>
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>
              <Row className="g-3">
                <Col xs={4} sm={3} xxl={3}>
                  <Form.Group className="mb-2">
                    <Form.Label>Prefijo</Form.Label>
                    <Form.Select {...register("pre")} className="custom-select-no-arrow align-selector">
                      {telefonos.map((banco) => (
                        <option key={banco.value} value={banco.value}>
                          {banco.label}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col xs={8} sm={9} xxl={9}>
                  <Form.Group className="mb-2">
                    <Form.Label>Número teléfonico</Form.Label>
                    <Form.Control onChange={numero} type="text" inputMode="numeric" maxLength="7" value={telefono} />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col xs={12}>
                  <Form.Group className="mb-2">
                    <Form.Label>Token de autorización</Form.Label>
                    <Form.Control
                      onChange={tokenc2p}
                      type="text"
                      inputMode="numeric"
                      placeholder="Ingrese 8 dígitos"
                      maxLength="8"
                      {...register("token")}
                    />
                    <Link
                      to={{
                        pathname: "/informacion",
                      }}
                      state={{ c2p }}
                      className="no-line"
                    >
                      <span className="info-token">¿Cómo puedo generar mi token?</span>
                    </Link>
                  </Form.Group>
                </Col>
              </Row>
            </>
          </div>
        </div>
        <Button type="submit" className="pay-btn">
          {changeForm ? (
            <>
              <div className="spinner"></div>
            </>
          ) : (
            <span>Pagar</span>
          )}
        </Button>
      </form>
    </div>
  );
};

export default PagoC2P;
